import React, { useEffect } from 'react'
import TextField from '@material-ui/core/TextField'
import Grid from '@material-ui/core/Grid'
import { useForm, Controller } from 'react-hook-form'
import { SkywatchDialog } from '../PopUps/SkywatchDialog'
import FlexView from 'react-flexview/lib'
import NewFillButton from '../Core/NewFillButton'
import AlternateEmailIcon from '@material-ui/icons/AlternateEmail'
import { ElevatedCircle } from '../Core/ElevatedCircle'
import { MenuItem, Checkbox, FormControlLabel, Typography, Divider } from '@material-ui/core'
import Autocomplete from '@material-ui/lab/Autocomplete'
import { MotocyclesApi } from '../../api/motorcycles.api'
import { GlobalTextField } from '../Core/Input/ControlledTextField'
import { PolicyManagementContextStore } from '../../context/PolicyManagementContext'
import { showError } from '../../services/utils'
import { TextDivider } from '../Core/TextDivier'

export const ManageRefundPopup = ({ open, body, onConfirm, onCancel, ...props }) => {
  const { register, errors, getValues, setValue, triggerValidation, control } = useForm()
  const [selectGroupValue, setSelectGroupValue] = React.useState('Base Mile Group')
  const handleClose = () => {
    onCancel && onCancel()
  }
  const myPoliciesContext = React.useContext(PolicyManagementContextStore)

  const [options, setOptions] = React.useState([])
  const [motorcycleToRefund, setMotorcycleToRefund] = React.useState({})
  const [policyToRefund, setPolicyToRefund] = React.useState({})
  const [motorcyclesCheckboxDisable, setMotorcyclesCheckboxDisable] = React.useState(false)
  const [policiesCheckboxDisable, setPoliciesCheckboxDisable] = React.useState(false)
  const [policiesArray, setPoliciesArray] = React.useState([])

  const Confirm = async () => {
    let valid = await triggerValidation()
    if (!valid) {
      if (!policyToRefund.insuredVehicles) {
        showError('Please choose the policy you wish to refund')
        return
      }
      return
    }

    //handleClose()
    const values = getValues()
    const data = {
      refundComment: values['refundComment'],
      refundReason: values['refundReason'],
      motorcycles: [],
    }
    if (policyToRefund.estimatedMilesInsurance) {
      for (const key of Object.keys(values).filter(x => x.startsWith('vehicle_'))) {
        const id = key.replace('vehicle_', '')
        if (policyToRefund.insuredVehicles.filter(iv => iv.id == id).length) {
          data.motorcycles.push({
            id: id,
            miles: values[key],
          })
        }
      }
    } else {
      data.motorcycles = [
        {
          id: motorcycleToRefund.id,
          miles: values['milesamount'],
        },
      ]
    }
    onConfirm && onConfirm({ requestData: data, policyToRefund })
  }

  useEffect(() => {
    if (myPoliciesContext.all_policies.length === 1) {
      setPolicyToRefund(myPoliciesContext.all_policies[0])
      setPoliciesCheckboxDisable(true)
    } else {
      setPoliciesArray([...myPoliciesContext.all_policies.slice(-2)])
    }
  }, [])

  useEffect(() => {
    if (policyToRefund.insuredVehicles) {
      if (policyToRefund.insuredVehicles.length === 1) {
        setMotorcycleToRefund(policyToRefund.insuredVehicles[0])
        setMotorcyclesCheckboxDisable(true)
      }
    }
  }, [policyToRefund])

  return (
    <SkywatchDialog
      open={open}
      closeDialog={handleClose}
      maxWidth={'xs'}
      shouldScroll={true}
      circleHeader={
        <ElevatedCircle>
          {' '}
          <AlternateEmailIcon className="blue" />{' '}
        </ElevatedCircle>
      }
      closeTitle={null}
    >
      <FlexView column>
        <div className="text-title blue bold margin-top-basic textcenter margin-bottom-basic">
          {policyToRefund.estimatedMilesInsurance ? 'Miles Adjustments' : null}
        </div>
        <Grid container spacing={3}>
          {policyToRefund && !policyToRefund.estimatedMilesInsurance && (
            <Grid item xs={12}>
              <div className="textcenter margin-bottom-basic">
                <TextField
                  InputLabelProps={{ className: 'avenir-book' }}
                  inputRef={register({ required: true })}
                  error={!!errors.year}
                  helperText={!!errors.year ?? 'Amount is required'}
                  autoComplete="amount"
                  type="number"
                  onInput={e => (e.target.value = Math.max(0, parseInt(e.target.value)).toString().slice(0, 8))}
                  label={'Insert miles amount to be refunded'}
                  fullWidth
                  variant="outlined"
                  autoFocus
                  name="milesamount"
                />
              </div>
            </Grid>
          )}
          <Grid item xs={12}>
            <div className="textcenter margin-bottom-basic">
              {[...myPoliciesContext.all_policies]
                .filter(p => !(p.tenure > 1 && p.policy_status === 'Scheduled'))
                .sort((a, b) => a.validFromUtc - b.validFromUtc)
                .map((item, index) => (
                  <FormControlLabel
                    control={
                      <Checkbox
                        name="policies"
                        inputRef={register({ required: true })}
                        color="primary"
                        disabled={policiesCheckboxDisable}
                        checked={item === policyToRefund}
                        onChange={e => {
                          setPolicyToRefund(item)
                        }}
                      />
                    }
                    label={`${item.estimatedMilesInsurance ? '*' : ''} ${item.policyNumber}-${item.tenure}`}
                  />
                ))}
            </div>
          </Grid>

          <Grid item xs={12}>
            {!!policyToRefund.insuredVehicles && (
              <div className="textcenter margin-bottom-basic">
                {!policyToRefund.estimatedMilesInsurance &&
                  policyToRefund.insuredVehicles.map((item, index) => (
                    <FormControlLabel
                      key={index}
                      control={
                        <Checkbox
                          name="motorcycles"
                          inputRef={register}
                          color="primary"
                          disabled={motorcyclesCheckboxDisable}
                          checked={item === motorcycleToRefund}
                          onChange={e => {
                            setMotorcycleToRefund(item)
                          }}
                        />
                      }
                      label={`${item['make']} ${item['model']} ${item['year']}`}
                    />
                  ))}
                {policyToRefund.estimatedMilesInsurance && (
                  <Grid item xs={12}>
                    {policyToRefund.insuredVehicles.map((item, index) => (
                      <div key={index} className="textcenter margin-bottom-basic">
                        <TextField
                          InputLabelProps={{ className: 'avenir-book' }}
                          inputRef={register({ required: true })}
                          error={!!errors[`vehicle_${item.id}`]}
                          helperText={!!errors[`vehicle_${item.id}`] ?? 'Amount is required'}
                          autoComplete="amount"
                          type="number"
                          label="Insert current odometer value"
                          fullWidth
                          variant="outlined"
                          autoFocus
                          name={`vehicle_${item.id}`}
                        />
                        <Typography variant="body1" className="textcenter">
                          {`${item['make']} ${item['model']} ${item['year']}`}
                        </Typography>
                        <Typography variant="body2" className="textcenter margin-bottom-basic">
                          Last odometer value: {item.last_odometer_value == null ? 'No Odometer' : item.last_odometer_value}
                        </Typography>
                        {index != policyToRefund.insuredVehicles.length - 1 && <Divider />}
                      </div>
                    ))}
                  </Grid>
                )}{' '}
              </div>
            )}
          </Grid>
        </Grid>

        <div className="margin-top-basic textcenter">
          <Controller
            rules={{ validate: field => field && field != 'none' }}
            name="refundReason"
            defaultValue={'none'}
            control={control}
            error={!!errors.refundreason}
            helperText={!!errors.refundreason && 'Cancellation reason is required'}
            as={
              <TextField fullWidth select variant="outlined">
                <MenuItem disabled value={'none'}>
                  Choose Refund Reason
                </MenuItem>
                <MenuItem value="WrongCharge">Wrong charge</MenuItem>
                <MenuItem value="DuplicateCharges">Duplicate charges</MenuItem>
                <MenuItem value="ReplacementPayment">Replacement payment</MenuItem>
                <MenuItem value="DefaultMileage">Default Mileage</MenuItem>
                <MenuItem value="Other">Other</MenuItem>
              </TextField>
            }
          />
        </div>

        <div className="textcenter margin-top-basic">
          <TextField
            InputLabelProps={{ className: 'avenir-book' }}
            inputRef={register({ required: true })}
            error={!!errors.refundComment}
            helperText={!!errors.refundComment ?? 'Refund comment is required'}
            autoComplete="Refund Comment"
            type="text"
            label="Refund Comment"
            fullWidth
            variant="outlined"
            autoFocus
            name="refundComment"
          />
        </div>

        <NewFillButton onClick={Confirm}>
          {policyToRefund && policyToRefund.estimatedMilesInsurance ? 'Approve Odometer' : 'Refund'}
        </NewFillButton>
        <div onClick={handleClose} className="margin-bottom-basic text-body textcenter gray underline clickable">
          Close
        </div>
      </FlexView>
    </SkywatchDialog>
  )
}
